import { PersonCompanyRolePersonFlagCompositeEntity } from '@nk/data-entities-lib';

export const PAGE_LIMIT = 10;

// TODO: unit tests
export function getLatestCeoRole(
  data: PersonCompanyRolePersonFlagCompositeEntity[],
): PersonCompanyRolePersonFlagCompositeEntity {
  return (
    data &&
    data
      .filter((x) => x.company_role.company_role_key === 'ceo' || x.company_role.company_role_key === 'external_ceo')
      .sort((a, b) => (a.person_company_role.from_date < b.person_company_role.from_date ? 1 : -1))[0]
  );
}
